import {whenReady, toggleClassOnClick} from "./_base";

whenReady(() => {
    let navaLink = document.getElementById('nava');
    toggleClassOnClick('show-tooltip', nava, nava);
});
